import React, { useState } from 'react'
import { cn } from '@/shared/lib/utils'
import styles from './ActionHeader.module.scss'
import { MaterialIcon } from '@/ui/material-icon'
import { Input } from '@/ui/input'
import { Button } from '@/ui/button'

interface Action {
    label?: string;
    icon?: string;
    onClick: () => void;
    variant?: 'primary' | 'icon';
    ariaLabel?: string;
    key: string;
}

interface ActionHeaderProps {
    title: string
    search?: string
    onSearchChange?: (value: string) => void
    searchPlaceholder?: string
    searchInputClassName?: string
    leadingActions?: Action[]
    actions?: Action[]
    className?: string
    children?: React.ReactNode
}

export default function ActionHeader({
    title,
    search,
    onSearchChange,
    searchPlaceholder = 'Search...',
    searchInputClassName,
    leadingActions = [],
    actions = [],
    className,
    children,
}: Readonly<ActionHeaderProps>) {

    const [rotatingKey, setRotatingKey] = useState<string | null>(null)

    const handleIconClick = (
        e: React.MouseEvent,
        action: Action
    ) => {
        e.stopPropagation()

        // Only animate refresh (or any key you want)
        if (action.key === 'refresh-pipelines') {
            setRotatingKey(action.key)

            setTimeout(() => {
                setRotatingKey(null)
            }, 500)
        }

        action.onClick()
    }

    return (
        <div className={cn(styles.actionHeader, className)}>
            <h1 className={styles.pageTitle}>{title}</h1>

            <div className={styles.headerActions}>
                {/* ⚡ Leading actions */}
                {leadingActions.map((action) => {
                    if (action.variant === 'icon') {
                        return (
                            <Button
                                key={action.key}
                                variant="outline"
                                size="icon"
                                onClick={(e) => handleIconClick(e, action)}
                                aria-label={action.ariaLabel}
                                className={styles.iconBtn}
                            >
                                {action.icon && (
                                    <MaterialIcon
                                        name={action.icon}
                                        size={18}
                                        className={
                                            rotatingKey === action.key
                                                ? styles.rotateIcon
                                                : ''
                                        }
                                    />
                                )}
                            </Button>
                        )
                    }

                    return (
                        <Button
                            key={action.key}
                            onClick={(e) => {
                                e.stopPropagation()
                                action.onClick()
                            }}
                            className={styles.primaryBtn}
                        >
                            {action.icon && <MaterialIcon name={action.icon} size={18} />}
                            {action.label}
                        </Button>
                    )
                })}

                {/* 🔍 Search */}
                {search !== undefined && onSearchChange && (
                    <div className={styles.searchWrapper}>
                        <MaterialIcon name="search" className={styles.searchIcon} />
                        <Input
                            value={search}
                            onChange={e => onSearchChange(e.target.value)}
                            placeholder={searchPlaceholder}
                            className={cn(styles.searchInput, searchInputClassName)}
                        />
                    </div>
                )}

                {/* ⚡ Custom slot */}
                {children}

                {/* ⚡ Actions */}
                {actions.map((action) => {
                    if (action.variant === 'icon') {
                        return (
                            <Button
                                key={action.key}
                                variant="outline"
                                size="icon"
                                onClick={(e) => handleIconClick(e, action)}
                                aria-label={action.ariaLabel}
                                className={styles.iconBtn}
                            >
                                {action.icon && (
                                    <MaterialIcon
                                        name={action.icon}
                                        size={18}
                                        className={
                                            rotatingKey === action.key
                                                ? styles.rotateIcon
                                                : ''
                                        }
                                    />
                                )}
                            </Button>
                        )
                    }

                    return (
                        <Button
                            key={action.key}
                            onClick={(e) => {
                                e.stopPropagation()
                                action.onClick()
                            }}
                            className={styles.primaryBtn}
                        >
                            {action.icon && <MaterialIcon name={action.icon} size={18} />}
                            {action.label}
                        </Button>
                    )
                })}
            </div>
        </div>
    )
}